export default "__VITE_ASSET__Li6ffnUX__"